import { Routes } from '@angular/router';
import { HomeCalendarComponent } from './pages/home-calendar/home-calendar.component';
import { EventFormComponent } from './pages/event-form/event-form.component';
import { PlanningComponent } from './pages/planning/planning.component';
import { CostListComponent } from './pages/cost-list/cost-list.component';
import { PlanningFaComponent } from './pages/planning-fa/planning-fa.component';
import { authGuard } from './core/guards/auth.guard';
import { AuthenticationComponent } from './pages/authentication/authentication.component';
import { freelanceGuard } from './core/guards/freelance.guard';

export const routes: Routes = [
    {path: 'calendar', component: HomeCalendarComponent,
        children: [
            {path: ':idUser', component: HomeCalendarComponent},
            {path: ':idUser/:sDate', component: HomeCalendarComponent},
        ],
        canActivate: [authGuard]
    },
    {path: 'planning', component: PlanningComponent, canActivate: [authGuard, freelanceGuard]},
    {path: 'event/:idEvent', component: EventFormComponent, canActivate: [authGuard]},
    {path: 'event/:idEvent/costList', component: CostListComponent, canActivate: [authGuard]},
    {path: 'event/:idEvent/planning-fa', component: PlanningFaComponent, canActivate: [authGuard]},
    {path: 'token', component: AuthenticationComponent},
    {path: '**', redirectTo: 'calendar', pathMatch: 'full'}
];
